module.exports = __webpack_public_path__ + "static/media/what-is-wpkt.786217ba.svg";